import {charcoal} from '../sass/base/_exports.sass';

export const KeyboardIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1, width = 18, height = 18} = props;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 14.625H2.25C1.95163 14.625 1.66548 14.5065 1.4545 14.2955C1.24353 14.0845 1.125 13.7984 1.125 13.5V5.625C1.125 5.32663 1.24353 5.04048 1.4545 4.82951C1.66548 4.61853 1.95163 4.5 2.25 4.5H15.75C16.0484 4.5 16.3345 4.61853 16.5455 4.82951C16.7565 5.04048 16.875 5.32663 16.875 5.625V13.5C16.875 13.7984 16.7565 14.0845 16.5455 14.2955C16.3345 14.5065 16.0484 14.625 15.75 14.625ZM2.25 5.625V13.5H15.75V5.625H2.25Z"
        fill={color}
      />
      <path
        d="M5.625 11.25H11.8125V12.375H5.625V11.25ZM3.375 6.75H4.5V7.875H3.375V6.75ZM5.625 6.75H6.75V7.875H5.625V6.75ZM7.875 6.75H9V7.875H7.875V6.75ZM10.125 6.75H11.25V7.875H10.125V6.75ZM3.375 11.25H4.5V12.375H3.375V11.25ZM3.375 9H4.5V10.125H3.375V9ZM5.625 9H6.75V10.125H5.625V9ZM7.875 9H9V10.125H7.875V9ZM12.375 6.75H14.625V7.875H12.375V6.75ZM12.375 9H14.625V10.125H12.375V9ZM10.125 9H11.25V10.125H10.125V9ZM12.9375 11.25H14.625V12.375H12.9375V11.25Z"
        fill={color}
      />
    </svg>
  );
};
